import { defineMessages } from 'react-intl';

const paymentStatusesText = defineMessages({
  AUTHORIZED: {
    id: 'inbox.payment_status.authorized',
    defaultMessage: 'Pending'
  },
  CAPTURED: {
    id: 'inbox.payment_status.captured',
    defaultMessage: 'Paid'
  },
  RELEASED: {
    id: 'inbox.payment_status.released',
    defaultMessage: 'Released'
  },
  FAILED: {
    id: 'inbox.payment_status.failed',
    defaultMessage: 'Failed'
  },
  RELEASING: {
    id: 'inbox.payment_status.releasing',
    defaultMessage: 'Releasing'
  },
  CANCELLED: {
    id: 'inbox.payment_status.canceled',
    defaultMessage: 'Released'

  },
  SCHEDULED: {
    id: 'inbox.payment_status.scheduled',
    defaultMessage: 'Scheduled'
  },
  HELD: {
    id: 'inbox.payment_status.held',
    defaultMessage: 'Released'
  },
  ERROR: {
    id: 'inbox.payment_status.unknown',
    defaultMessage: 'Error'
  }
});

export const paymentStatus = {
  AUTHORIZED: {
    text: paymentStatusesText.AUTHORIZED,
    class: 'warning'
  },
  CAPTURED: {
    text: paymentStatusesText.CAPTURED,
    class: 'success'
  },
  RELEASED: {
    text: paymentStatusesText.RELEASED,
    class: 'blue'
  },
  FAILED: {
    text: paymentStatusesText.FAILED,
    class: 'danger'
  },
  RELEASING: {
    text: paymentStatusesText.RELEASING,
    class: 'warning'
  },
  CANCELLED: {
    text: paymentStatusesText.CANCELLED,
    class: 'blue'
  },
  SCHEDULED: {
    text: paymentStatusesText.SCHEDULED,
    class: 'warning'
  },
  HELD: {
    text: paymentStatusesText.HELD,
    class: 'blue'
  },
  ERROR: {
    text: paymentStatusesText.ERROR,
    class: 'danger'
  }
};

export const paymentErrors = defineMessages({
  UNABLE_TO_AUTHENTICATE_CARD: {
    id: 'api.payment_errors.unable_to_authenticate_card',
    defaultMessage: 'We were unable to authenticate your card. Please try again.'
  }
});
